import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetActiveGMUStoresRequest = {
  pageNumber: number;
  pageSize: number;
  merchantId?: number;
  onlyActiveStores?: boolean;
};

export type IGMUStore = {
  id: number;
  merchantId: number;
  merchantName: string;
  gmuStoreId: string;
  gmuTenantId: number;
  integratorId: number;
  integratorUid: string;
  integratorPwd: string;
  integratorGbAlias: string;
  integratorEArchiveGbAlias: string | null;
  storeCreateDate: string;
};

export type GetActiveGMUStoresResponse = BasePagingResponse<Array<IGMUStore>>;

async function getActiveGMUStores(
  data: GetActiveGMUStoresRequest
): Promise<GetActiveGMUStoresResponse> {
  try {
    return (await axiosInstance.post("/Merchant/GetActiveGMUStores", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetActiveGMUStores() {
  return useMutation<GetActiveGMUStoresResponse, Error, GetActiveGMUStoresRequest>(
    (variables) => getActiveGMUStores(variables)
  );
}
